<template>
  <div class="Tinformation" v-wechat-title="$route.meta.title = title()">
    <van-tabs v-model="activeName" color="#409eff" @change="tabSwitch">
      <van-tab name="a" title="终端信息">
        <van-cell :value="clientInfo.clName">
          <span slot="title">
            <span class="ifctop"></span>设备名称
          </span>
        </van-cell>
        <van-cell :value="clientInfo.clDisk">
          <span slot="title">
            <span class="ifc"></span>设备内存
          </span>
        </van-cell>
        <van-cell :value="clientInfo.clNo">
          <span slot="title">
            <span class="ifc"></span>设备
          </span>
        </van-cell>
        <van-cell :value="clientInfo.clMac">
          <span slot="title">
            <span class="ifc"></span>设备MAC
          </span>
        </van-cell>
        <van-cell :value="clientInfo.clScreenNum">
          <span slot="title">
            <span class="ifc"></span>屏幕数量
          </span>
        </van-cell>
        <van-cell :value="clientInfo.clAddress">
          <span slot="title">
            <span class="ifc"></span>设备定位
          </span>
        </van-cell>
        <van-cell :value="clientInfo.clAuthState == '1' ? '已授权':'未授权'">
          <span slot="title">
            <span class="ifc"></span>是否授权
          </span>
        </van-cell>
        <van-cell title="" :value="clientInfo.clResolution">
          <span slot="title">
            <span class="ifc"></span>分辨率
          </span>
        </van-cell>
        <van-cell title="" :value="clientInfo.clRemark">
          <span slot="title">
            <span class="ifc"></span>备注
          </span>
        </van-cell>
        <van-cell title="" :value="clientInfo.clIp">
          <span slot="title">
            <span class="ifc"></span>设备IP
          </span>
        </van-cell>
        <van-cell title="" :value="clientInfo.clVersion" @click="showAllVersion">
          <span slot="title">
            <span class="ifc"></span>系统版本
          </span>
        </van-cell>
      </van-tab>
      <van-tab title="终端操作" name="b">
        <div class="orderList">
          <div class="operation-title">远程指令</div>
          <van-row gutter="20">
            <van-col style="padding-right: 0" span="6" class="operation-item" v-for="(item) in operationVolume"
                     :key="item.id"
                     @click="dialogShow = true">
              <div class="operation-item-img">
                <img :src="item.icIcon"/>
              </div>
              <div class="operation-item-title">
                {{ item.icName }}
              </div>
            </van-col>
            <!--  @click="dialogShow = true;onsubmit(item.icInstruction)"  -->
            <van-col span="6" class="operation-item" v-for="(item) in operation" :key="item.id"
                     @click="itemClick(item)">
              <div class="operation-item-img">
                <img :src="item.icIcon"/>
              </div>
              <div class="operation-item-title">
                {{ item.icName }}
              </div>
            </van-col>
          </van-row>
        </div>
        <div style="padding: 0 15px;margin-bottom: 20px">
          <van-button type="info" size="normal" block @click="onsubmit('5010')">远程监控</van-button>
        </div>

        <van-row gutter="0">
          <img :src="monitoring" style="width: 100%;padding: 5px;box-sizing: border-box;height: 200px" alt="">
        </van-row>
      </van-tab>
      <van-tab title="绑定任务" name="c">
        <div class="clientTaskInfoContent" v-if="clientTaskInfo.length > 0">
          <div class="clientTaskInfoList clientTaskInfoBlock" v-for="(item,index) in clientTaskInfo"
               :key="index">
            <div class="clientTaskInfoItem" style="justify-content: flex-end;">
              <van-button type="danger" size="mini" @click="deleteTask(item)">删除</van-button>
            </div>
            <div class="clientTaskInfoItem">
              <div class="clientTaskInfo_key">
                <div class="clientTaskInfo_key_icon"></div>
                任务名称
              </div>
              <div class="clientTaskInfo_val">
                {{ item.name }}
              </div>
            </div>
            <div class="clientTaskInfoItem">
              <div class="clientTaskInfo_key">
                <div class="clientTaskInfo_key_icon"></div>
                任务类型
              </div>
              <div class="clientTaskInfo_val">
                <!-- 替换任务-->
                {{ item.type == '1' ? '普通任务' : '普通任务' }}
              </div>
            </div>
            <div class="clientTaskInfoItem">
              <div class="clientTaskInfo_key">
                <div class="clientTaskInfo_key_icon"></div>
                播放模式
              </div>
              <div class="clientTaskInfo_val">
                <!--                替换模式-->
                {{ item.state == '1' ? '普通模式' : '普通模式' }}
              </div>
            </div>
            <div class="clientTaskInfoItem">
              <div class="clientTaskInfo_key">
                <div class="clientTaskInfo_key_icon"></div>
                播放日期
              </div>
              <div class="clientTaskInfo_val">
                {{ item.startTime.split('~')[0] }}~~{{ item.endTime.split('~')[0] }}
              </div>
            </div>
            <div class="clientTaskInfoItem">
              <div class="clientTaskInfo_key">
                <div class="clientTaskInfo_key_icon"></div>
                播放时段
              </div>
              <div class="clientTaskInfo_val">
                {{ item.startTime.split('~')[1] }}~~{{ item.endTime.split('~')[1] }}
              </div>
            </div>
            <div class="clientTaskInfoItem">
              <div class="clientTaskInfo_key">
                <div class="clientTaskInfo_key_icon"></div>
                任务周期
              </div>
              <div class="clientTaskInfo_val">
              </div>
            </div>
            <div class="clientTaskInfoItem">
              <div class="cycleList">
                <div class="cycleItem">
                  <div class="weekli" :class="item.mon == 'true' ? 'istrue' : ''">一</div>
                  <div class="weekli" :class="item.tue == 'true' ? 'istrue' : ''">二</div>
                  <div class="weekli" :class="item.wed == 'true' ? 'istrue' : ''">三</div>
                  <div class="weekli" :class="item.thur == 'true' ? 'istrue' : ''">四</div>
                  <div class="weekli" :class="item.fri == 'true' ? 'istrue' : ''">五</div>
                  <div class="weekli" :class="item.sat == 'true' ? 'istrue' : ''">六</div>
                  <div class="weekli" :class="item.sun == 'true' ? 'istrue' : ''">日</div>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div v-else>
          <van-empty description="暂无数据"/>
        </div>
      </van-tab>
      <van-tab title="定时开关机" name="d">
        <div v-if="clientTaskInfos.length === 0">
          <van-empty description="暂无数据"/>

        </div>
        <div class="dingshi" v-else>
          <nut-textinput
              v-model="end_time"
              label="关机时间："
              :clearBtn="false"
              :disabled="true"
          />
          <nut-textinput
              v-model="start_time"
              label="开机时间："
              :clearBtn="false"
              :disabled="true"
          />
          <div style="padding: 10px 16px;display: flex;flex-wrap:wrap">
            <div style="flex: 1;display: flex;justify-content: center;" v-for="(item,index) in checkboxData"
                 :key="index">
              <div
                   style="width: 35px;height: 35px;display: flex;justify-content: center;line-height:34px;border-radius: 100%;"
                   :class="item.value ? 'yes' :'no'">
                {{ item.label }}
              </div>
            </div>
          </div>
        </div>
        <div
            style="position:fixed;right: 10px;bottom:78px;left: 10px;height: 40px;display: flex;justify-content: space-between">
          <div style="display: flex;align-items: center;font-size: 12px;color: red">添加一条会覆盖上一条</div>
          <div style="width:40px;height: 40px;border: 1px solid #dadada;border-radius: 100%;
                    overflow:hidden;padding: 10px;box-sizing: border-box"
               @click="onEdit">
            <img :src="require('../assets/images/updata.png')" style="width: 100%;height: 100%;">
          </div>
        </div>
      </van-tab>
    </van-tabs>
    <nut-dialog :canDestroy="false" title="音量设置" :visible="dialogShow" @ok-btn-click="onsubmit('5004')"
                :closeOnClickModal="false"
                @close="dialogShow=false">
      <div style="padding-top: 20px;display: flex;justify-content: center">
        <van-slider v-model="volume" @change="setvolume" :min="0" style="width: 90%" :max="100">
          <div
              slot="button"
              class="custom-button"
          >
            {{ volume }}
          </div>
        </van-slider>
      </div>
    </nut-dialog>
    <nut-dialog :canDestroy="false" :title="dialogtitle" :visible="dialogShow2" @ok-btn-click="onsubmit"
                :closeOnClickModal="false"
                @close="dialogShow2=false">
      <div style="padding-top: 20px;display: flex;justify-content: center">
        {{ tipMsg }}
      </div>
    </nut-dialog>
    <van-overlay :show="show" style="z-index: 999">
      <div class="wrapper">
        <div class="block">截取中请稍后</div>
      </div>
    </van-overlay>
    <nut-datepicker
        :is-visible="isVisible4"
        type="time"
        title="请选择时间"
        defaultValue="09:06"
        @close="switchPicker('timeinfo')"
        @choose="setChooseValue4"/>
    <van-overlay :show="show1" style="display: flex;align-items: center">
      <div class="dingshi" style="width: 95%;margin: 0 auto">
        <nut-textinput
            v-model="end_time"
            label="关机时间："
            :clearBtn="false"
            :disabled="true"
            @click.native="onSetTime('end_time')"
        />
        <nut-textinput
            v-model="start_time"
            label="开机时间："
            :clearBtn="false"
            :disabled="true"
            @click.native="onSetTime('start_time')"
        />
        <div style="padding: 10px 16px;display: flex;flex-wrap:wrap">
          <div style="flex: 1;display: flex;justify-content: center;" v-for="(item,index) in checkboxData"
               :key="index">
            <div @click="setCheckbox(item.label)"
                 style="width: 35px;height: 35px;display: flex;justify-content: center;line-height:34px;border-radius: 100%;"
                 :class="item.value ? 'yes' :'no'">
              {{ item.label }}
            </div>
          </div>
        </div>
        <div style="width: 100%;text-align: right;padding: 16px;box-sizing: border-box">
          <van-button plain type="danger" size="small" @click="show1 = false">取消</van-button>
          <van-button type="info" size="small" style="margin-left: 10px" @click="onDingshi">确定</van-button>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import qs from 'qs'
import {Dialog, Notify, Toast} from 'vant'

export default {
  name: 'Tinformation',
  data() {
    return {
      activeName: 'a',
      id: 1,
      clientInfo: {},
      operationVolume: [{
        icIcon: '/static/images/volume.png',
        icInstruction: '5004',
        icName: '调节音量',
        icType: 'client',
        id: 1,
      }],
      operation: [
        {
          icIcon: '/static/images/restart.png',
          icInstruction: '5007',
          icName: '重启设备',
          icType: 'client',
          id: 2,
        },
        {
          icIcon: '/static/images/awaken.png',
          icInstruction: '5020',
          icName: '唤醒',
          icType: 'client',
          id: 3,
        },
        {
          icIcon: '/static/images/dormant.png',
          icInstruction: '5019',
          icName: '休眠',
          icType: 'client',
          id: 4,
        },
        {
          icIcon: '/static/images/shutdown.png',
          icInstruction: '5018',
          icName: '关机',
          icType: 'client',
          id: 5,
        },
        {
          icIcon: '/static/images/timing.png',
          icInstruction: '5012',
          icName: '清理定时',
          icType: 'client',
          id: 6,
        },
        {
          icIcon: '/static/images/clean.png',
          icInstruction: '5005',
          icName: '清理磁盘',
          icType: 'client',
          id: 7,
        },
        {
          icIcon: '/static/images/CleanTask.png',
          icInstruction: '5006',
          icName: '清理任务',
          icType: 'client',
          id: 8,
        },
      ],
      dialogShow: false,
      volume: 70,
      dialogShow2: false,
      dialogtitle: '发送指令',
      tipMsg: '',
      itemCode: '',
      clNo: '',
      monitoring: require("../assets/images/image.png"),
      show: false,
      start_time: "",
      end_time: "",
      timeinfo: "",
      clientTaskInfo: [],
      isVisible4: false,
      time_type: "start_time",
      checkboxData: [
        {value: true, label: '一'},
        {value: true, label: '二'},
        {value: true, label: '三'},
        {value: true, label: '四'},
        {value: true, label: '五'},
        {value: true, label: '六'},
        {value: true, label: '日'}
      ],
      group: [],
      checkall: true,
      isDisabled: true,
      show1: false,
      clientTaskInfos: []
    }
  },
  mounted() {
    this.id = this.$route.query.id
    this.clNo = this.$route.query.clNo
    this.getClientInfo()
  },
  methods: {
    onEdit() {
      this.show1 = true
    },
    tabSwitch(index) {
      if (index === "d") {
        this.getDingshiInfo()
      }
    },
    setCheckbox(val) {
      let index = this.checkboxData.map(res => res.label).indexOf(val)
      this.checkboxData[index].value = !this.checkboxData[index].value

      this.$set(this.checkboxData, index, this.checkboxData[index])
      this.checkall = true

      for (let i = 0; i < this.checkboxData.length; i++) {
        if (!this.checkboxData[i].value) {
          this.checkall = false
          break
        }
      }
    },
    onDingshi() {
      this.$ajax.post("etv/socket.json", qs.stringify({
        clientNos: this.clNo,
        instruction: 5012,
        ids: this.id
      })).then(res => {
        if (res.data.code === 0) {
          this.$ajax({
            url: "/etv/insertTimedTask.json",
            method: "post",
            transformResponse: [function (data) {
              if (data instanceof FormData) {
                return data
              }
              data = qs.stringify(data)
              return data
            }],
            data: {
              clients: [{
                clientNo: this.clNo,
                id: this.id,
              }],

              timedTaskArr: [
                {
                  ttMon: this.checkboxData[0].value,
                  ttTue: this.checkboxData[1].value,
                  ttWed: this.checkboxData[2].value,
                  ttThu: this.checkboxData[3].value,
                  ttFri: this.checkboxData[4].value,
                  ttSat: this.checkboxData[5].value,
                  ttSun: this.checkboxData[6].value,
                  ttOffTime: this.end_time,
                  ttOnTime: this.start_time,
                  ttState: true,
                  checkall: this.checkall,
                }
              ],
              type: ""
            }
          }).then(res => {
            if (res.data.code === 0) {
              Notify({type: 'success', message: res.data.msg})
              this.getDingshiInfo()
            } else {
              Notify({type: 'danger', message: res.data.msg})
            }
            this.show1 = false
          })
        }
      })
    },
    getDingshiInfo() {
      this.$ajax.post("/etv/selectClientByClId.json", qs.stringify({
        id: this.id
      })).then(res => {
        if (res.data.code === 0) {
          this.clientTaskInfos = res.data.data.clientTaskInfo
          if (this.clientTaskInfos.length === 0) return

          this.start_time = res.data.data.clientTaskInfo[0].ttOnTime
          this.end_time = res.data.data.clientTaskInfo[0].ttOffTime
          this.checkboxData[0].value = res.data.data.clientTaskInfo[0].ttMon === "true"
          this.checkboxData[1].value = res.data.data.clientTaskInfo[0].ttTue === "true"
          this.checkboxData[2].value = res.data.data.clientTaskInfo[0].ttWed === "true"
          this.checkboxData[3].value = res.data.data.clientTaskInfo[0].ttThu === "true"
          this.checkboxData[4].value = res.data.data.clientTaskInfo[0].ttFri === "true"
          this.checkboxData[5].value = res.data.data.clientTaskInfo[0].ttSat === "true"
          this.checkboxData[6].value = res.data.data.clientTaskInfo[0].ttSun === "true"
        }
      })
    },

    onSetTime(time_type) {
      this.time_type = time_type
      this.isVisible4 = true
    },
    switchPicker() {
      this.isVisible4 = false
    },
    setChooseValue4(data) {
      if (this.time_type === "start_time") {
        this.start_time = data[2]
      } else {
        this.end_time = data[2]
      }
      this.isVisible4 = false
    },
    getClientInfo() {
      this.$ajax.post('/etv/selectClientByClId.json', qs.stringify({
        id: this.id,
      })).then(res => {
        if (res.data.code === 0) {
          this.clientInfo = res.data.data.clientInfo
        }
      })
      this.$ajax.post('/etv/selectClientCommonTaskByClId.json', qs.stringify({
        id: this.id,
      })).then(res => {
        if (res.data.code === 0) {
          this.clientTaskInfo = res.data.data.taskList
        }
      })

    },

    setvolume(val) {
      this.volume = val
    },

    onsubmit(icInstruction) {
      let data = {
        clientNos: this.clientInfo.clNo,
        ids: this.clientInfo.id,
        instruction: icInstruction,
      }
      if (icInstruction) {
        data.instruction = icInstruction
      } else {
        data.instruction = this.itemCode
      }

      if ('5004' === icInstruction) {
        data = {
          clientNos: this.clientInfo.clNo,
          ids: this.clientInfo.id,
          instruction: icInstruction,
          volNum: this.volume,
        }
      }
      this.$ajax.post('/etv/socket.json', qs.stringify(data)).then(res => {
        if (res.data.code === 0) {
          Notify({type: 'success', message: '发送成功'})
          if (icInstruction === '5010') {
            this.show = true
            setTimeout(() => {
              this.$ajax.post("/etv/selectByClientNo.json", qs.stringify({
                clientNos: this.clientInfo.clNo
              })).then(res => {
                this.show = false
                if (res.data.code === 0) {
                  this.monitoring = "/" + res.data.data[0].monitorPath[0].eiSavePath
                } else {
                  Notify({type: 'danger', message: res.data.msg})
                }
              })
            }, 1000 * 10)


          }
        } else {
          Notify({type: 'danger', message: res.data.msg})
        }
        this.dialogShow = false;
        this.dialogShow2 = false;
      })

    },
    // 点击显示完全版本信息
    showAllVersion() {
      Toast(this.clientInfo.clVersion);
    },
    itemClick(res) {
      this.dialogShow2 = true;
      console.log(this.dialogShow2);
      this.tipMsg = '是否确定' + res.icName + '?'
      this.itemCode = res.icInstruction
    },
    title() {
      switch (this.activeName) {
        case 'a':
          return '终端信息';
        case 'b':
          return '终端操作';
        case 'c':
          return '绑定任务';
      }
    },
    deleteTask(data) {
      Dialog.confirm({
        title: '删除'
        , message: '是否确定删除任务？',
      }).then(() => {
        this.$ajax.post('/etv/deleteCommonTaskByClientId.json', qs.stringify({
          id: this.id,
          clientNo: this.clNo,
          taskId: data.id
        })).then(res => {
          if (res.data.code === 0) {
            Toast('删除成功')
            this.getClientInfo()
          } else {
            Toast(res.data.msg)
          }
        })
      }).catch(() => {
      })
    }
  },
}
</script>

<style lang="scss">
@import "../../public/static/css/app";

.nut-button[disabled] {
  background: #dadada !important;
}

.van-toast__text {
  word-wrap: break-word;
  word-break: break-all;
}

.Tinformation {
  height: calc(100% - 70px) !important;

  .van-overlay {
    z-index: 999 !important;

    .wrapper {
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      .block {
        color: #cccccc;
      }
    }
  }

  .empty {
    height: 100px;
    width: 100%;
    text-align: center;
    line-height: 100px;
    color: #8c8c8c;
  }

  .van-tabs {
    height: 100%;
  }

  .van-tabs__content {
    height: calc(100% - 44px);
    overflow-y: auto;
  }

  .van-cell {
    .van-cell__title {
      flex: 1;
    }

    .ifctop {
      display: inline-block;
      width: 12px;
      height: 12px;
      border-radius: 10px;
      margin-right: 5px;
      background: #ff0000;
    }

    .ifc {
      display: inline-block;
      width: 12px;
      height: 12px;
      border-radius: 10px;
      margin-right: 5px;
      background: #1B89FA;
    }

    .van-cell__value {
      flex: 2;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }

  .orderList {
    padding: 0 20px;

    .van-row {
      display: flex;
      width: 100%;
      justify-content: flex-start;
      flex-direction: row;
      flex-wrap: wrap;
      margin: 0 !important;

      .operation-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 20px;
        text-align: center;
        font-size: 12px;

        img {
          width: 44px;
          height: 44px;
        }
      }

      .operation-item:nth-last-child(1) {
        padding-left: 0px !important;
      }

    }

    .operation-title {
      height: 34px;
      line-height: 34px;
      font-size: 16px;
      border-bottom: 1px solid $uni-border-bottom-color;
      margin-top: 5px;
      margin-bottom: 20px;
    }

  }

  .custom-button {
    border-radius: 100%;
    height: 20px;
    width: 20px;
    border: 1px solid #f1f1f1;
    font-size: 12px;
    background: #409eff;
    line-height: 20px;
    text-align: center;
    color: #f1f1f1;
  }

  .nut-dialog-content {
    overflow: hidden;
  }

  .clientTaskInfoContent {
    height: calc(100% - 50px);

    .clientTaskInfoBlock {
      margin-bottom: 10px;
      margin-top: 10px;
      display: flex;
      flex-direction: column;
      background: #fff;
      font-size: 12px;

      .clientTaskInfoItem {
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid $uni-bg-color-title;
        padding: 10px 15px 10px 20px;
        box-sizing: border-box;

        .clientTaskInfo_key {
          width: 100px;
          display: flex;
          align-items: center;

          .clientTaskInfo_key_icon {
            height: 10px;
            width: 10px;
            border-radius: 100%;
            background: #1B89FA;
            margin-right: 5px;
          }

        }

        .clientTaskInfo_val {
          color: #969696;
          flex: 1;
          text-align: right;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .cycleList {
          display: flex;
          width: 100%;

          .cycleItem {
            display: flex;
            flex-direction: row;
            justify-content: space-around;
            width: 100%;

            .weekli {
              width: 20px;
              height: 20px;
              border-radius: 50%;
              text-align: center;
              line-height: 20px;
              background: #fff;
              color: #1B89FA;
              border: 1px solid #1B89FA;
            }

            .istrue {
              background: #1B89FA;
              color: #fff;

            }
          }
        }
      }

      .clientTaskInfoItem:last-child {
        border-bottom: none;
      }

      .btnList {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        padding-right: 20px;
        box-sizing: border-box;

        .btn {
          display: flex;
          flex: 0 0 auto;
          height: 27px;
          line-height: 27px;
          background: #1B89FA;
          margin: 10px 0 10px 10px;
          width: 50px;
          justify-content: center;
          border-radius: 5px;
          color: #fff;

          &.btn-modify {
          }

          &.btn-send {
          }

          &.btn-delete {
            background: #fff;
            color: red;
            border: 1px solid red;
          }
        }
      }
    }
  }

  .dingshi {
    padding: 30px 0 10px 0;
    box-sizing: border-box;
    background: white;

    .yes {
      background: #1B89FA;
      color: #fff;
    }

    .no {
      background: #dadada;
      color: #333333;
    }

    .nut-textinput-disabled input {
      background-color: white;
    }

    .nut-textinput {
      padding: 0 16px;
      border-bottom: 1px solid #dddfe6;
    }

    .nut-textinput input {
      border: none;
      border-radius: 0;
      padding: 0 !important;
      text-align: right;
    }
  }

}
</style>
